<!--赖传峰-->
<!--2023/4/6-->
<template>
  <header class="header">
    <div>
      <!-- NOTE: 避免水合失败 -->
      <ClientOnly>
        <a
          v-if="userInfoStore.userId"
          :href="RoutePathOfDrive.ALL"
          style="display: flex;"
        >
          <LogoSVG />
        </a>
        <NuxtLinkLocale
          v-else
          :to="RoutePath.HOME"
          style="display: flex;"
        >
          <LogoSVG />
        </NuxtLinkLocale>

        <template #fallback>
          <div style="display: flex;"><LogoSVG /></div>
        </template>
      </ClientOnly>
      <div class="subtitle">
        {{ $t('home-page-title') }}
        <div class="divider" />
        <a
          href="/"
          target="_blank"
        >
          {{ $t('learn-more') }}
          <RightIcon
            :size="16"
            color="var(--color-primary)"
          />
        </a>
      </div>
    </div>
    <div style="margin-right: 20px;">
      <I18nMenu />
      <div style="margin-left: 32px;">
        <!-- NOTE: 防止水合失败 -->
        <ClientOnly>
          <HeaderBarAvatar v-if="userInfoStore.userId" />
          <a
            v-else
            class="pp-link-button sign-up-in"
            @click="() => showLoginDialog?.()"
          >
            {{ $t('basic-sign-up-or-in') }}
          </a>
        </ClientOnly>
      </div>
    </div>
  </header>
</template>

<script
  lang="ts"
  setup
>

import {
  inject,
  onMounted,
} from '#imports'
import RightIcon from '~/components/icons/RightIcon.vue'
import I18nMenu from '~/layouts/basic/I18nMenu.vue'
import LogoSVG from '~/layouts/basic/LogoSVG.vue'
import HeaderBarAvatar from '~/layouts/common/HeaderBarAvatar.vue'
import { useUserInfo } from '~/store/userInfo'
import {
  InjectionKey,
  RoutePath,
  RoutePathOfDrive,
} from '~/types/enum'

const userInfoStore = useUserInfo()
const showLoginDialog = inject<ShowLoginDialog>(InjectionKey.SHOW_LOGIN_DIALOG)

onMounted(() => {
  userInfoStore.refresh()
})
</script>

<style
  lang="less"
  scoped
>
@import 'driveHeader.style';
</style>
